import React from 'react'
import './MenuItem.css'

function MenuItem({ item }) {
  return (
    <div onClick={item.cmd} key={item.menu} className="MenuItem">
      {item.menu}
    </div>
  )
}

export default MenuItem
